import { ClientOnly } from '@go-beyond/react'
import type { ReactNode } from 'react'
import { AuthProviderClient } from '../components/auth-provider-client.js'
import { NavigationProgress } from '../components/navigation-progress.js'
import { PortalContextSwitcher, PortalHeaderAccount } from '../components/portal-header-account.js'
import { PortalHeaderShell, PortalNavigationFirstPaint } from '../components/portal-header-shell.js'
import { PortalNavigationClient, type PortalShellData } from '../components/portal-sidebar-client.js'
import { NounPreviewProvider, prefetchNounPreviews } from '../components/noun-reference.js'

/**
 * Persistent app shell: SSR top bar stays mounted across soft navigation.
 * Auth + account chrome hydrate into reserved header slots; page bodies swap
 * underneath. Auth pages cover the chrome with a fixed full-viewport overlay.
 */
export default function RootLayout(props: { children: ReactNode; shell?: PortalShellData }) {
  return (
    <div className="portal-app-root min-h-dvh bg-[var(--surface)] text-[var(--ink)]">
      <PortalHeaderShell />

      <ClientOnly fallback={<PortalNavigationFirstPaint isProject={props.shell?.isProject || false} isTeam={props.shell?.isTeam || false} isMember={props.shell?.isMember || false} contextId={props.shell?.contextId || ''} contextName={props.shell?.contextName || ''} organizationName={props.shell?.organizationName || ''} canManageContext={props.shell?.canManageContext || false} isCurrentMember={props.shell?.isCurrentMember || false}>{props.children}</PortalNavigationFirstPaint>}>
        <AuthProviderClient>
          <NounPreviewProvider prefetch={prefetchNounPreviews}>
            <NavigationProgress />
            <PortalNavigationClient shell={props.shell}>{props.children}</PortalNavigationClient>
            <PortalContextSwitcher shell={props.shell} />
            <PortalHeaderAccount />
          </NounPreviewProvider>
        </AuthProviderClient>
      </ClientOnly>
    </div>
  )
}
